import React from "react";

const NotFound = () => {
  return (
    <div
      style={{ backgroundColor: "#F6F6F6" }}
      className="text-center py-3 mt-4"
    >
      <img
        className="img-fluid"
        src={
          "https://www.pngkey.com/png/detail/147-1473883_404-error-404-not-found-png.png"
        }
        alt=""
      />
    </div>
  );
};

export default NotFound;
